import { render } from "./FileDownload.vue?vue&type=template&id=0116d9df&scoped=true"
import script from "./FileDownload.vue?vue&type=script&lang=js"
export * from "./FileDownload.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-0116d9df"

export default script